module.exports = __webpack_public_path__ + "media/home_after_work.09aab2bd.ogg";